import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../Actions/setLoading';

const Picture404 = () => {
    // const dispatch = useDispatch()
    // useEffect(() => {
    //     setTimeout(() => {dispatch(setLoading());},1500)
    // },[dispatch])
    return ( 
        <div className='page_not_found'>
            <div className='page_not_found-body'>
                <img src='assets/images/handle-phone.png' alt='404-not found'/>
            </div>
            <div className='page_not_found-caption'>
                <h1>اووه متاسفیم</h1>
                <p>عکسی که گرفتید یا آن را آپلود کردید دارای مشکل کیفیت یا سایز است</p>
                <p>لطفا در صورت عکس گرفتن مطابق آموزش بالا عمل کنید. </p>
            </div>
        </div>
     );
}
 
export default Picture404;